module.exports = __webpack_public_path__ + "img/Shopee_Food_Logo.b5a6bbc0.svg";